// Import centralized API configuration
import { getApiBaseUrl as getCentralApiBaseUrl } from '../../Features/API/api';

// API Configuration
const API_CONFIG = {
  // Use centralized BASE_URL from Features/API/api.js
  get BASE_URL() {
    // Remove /api/ suffix from the centralized URL to get base
    const apiUrl = getCentralApiBaseUrl();
    return apiUrl.replace(/\/api\/?$/, '');
  },

  // API endpoints
  DOCS_URL: '/api/docs/',
  REDOC_URL: '/api/redoc/',
  SCHEMA_URL: '/api/schema/',
};

// Helper functions
export const getApiBaseUrl = () => getCentralApiBaseUrl(); // Use centralized version
export const getDocsUrl = (path = '') => `${API_CONFIG.BASE_URL}${API_CONFIG.DOCS_URL}${path}`;
export const getRedocUrl = () => `${API_CONFIG.BASE_URL}${API_CONFIG.REDOC_URL}`;
export const getSchemaUrl = () => `${API_CONFIG.BASE_URL}${API_CONFIG.SCHEMA_URL}`;

export default API_CONFIG;
